<template>
  <div class="jNavBarApp">
    <b-row
      class="navbar navbar-white navbar-expand-lg fixed-top">
      <b-col
        cols="10"
        style="display: flex; align-content: center;">
        <div>
          <img
            src="@/assets/image/home.png"
            height="30"
            style="cursor: pointer"
            @click="$router.replace('/home')">
        </div>
        <div class="text-application-detail m__l--15 m__t--7">
          {{ module }}
        </div>
      </b-col>
      <b-col
        cols="2"
        class="text-right">
        <!-- <i
          class="fa fa-sign-out fa-2x cusor-ponter"
          @click="logout"/> -->
        <div>
          <b-navbar-nav
            class="ml-auto">
            <j-nav-item-user :submenu="user.submenu" />
          </b-navbar-nav>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved,vue/name-property-casing */
import jNavItemUser from './jNavItemUser';

export default {
  name: 'jNavbarApp',
  components: {
    jNavItemUser,
  },
  props: {
    user: {
      type: Object,
      default() {
        return null;
      },
    },
    module: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
  },
  methods: {
    logout() {
      this.$router.replace('/logout');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/navbar/jNavbarApp.vue